import * as React from "react";
import { useEffect } from "react";
import { logout } from "../infrastructure/msal";

export const LogoutPage: React.FC = () => {
  useEffect(() => {
    const performLogout = async () => {
      try {
        await logout();
      } catch (error) {
        /* empty */
      }
    };

    if (window.self === window.top) {
      setTimeout(() => {
        performLogout();
      }, 100);
    }
  }, []);

  return (
    <div
      style={{
        display: "none",
        width: "0",
        height: "0",
        overflow: "hidden",
      }}
    >
      {}
    </div>
  );
};
